import React, {useContext, useEffect} from "react"
import AlertView from "../alert/AlertView";
import {getDocumentURL, getNodeCapability} from "../handler/ParentDataHandler";
import {getBaseUrl, parseCapabilitiesResponse} from "../util/Util";
import {CapabilityContext} from "../global/context/CapabilityContext";
import RouteStageTable from "../routeStageStatus/RouteStageTable";
import {STAGE_TAB_METRIC_KEY, logCounterMetric, RSWS_GET_CONFIG, RSWS_GET_STATION_CONFIG_SUCCESS} from "../util/MetricUtil";
import StageOverallStatus from "./StageOverallStatus";
import StageFilter from "./StageFilter";
import StageViewSelector from "./StageViewSelector";
import {DEFAULT_CAPABILITIES, PAGE_HEADERS, PLAN_MANAGEMENT_VIEW} from "../util/Constants";
import StageOverallStatusV2 from "./StageOverallStatusV2";
import {AssociateContext} from "../associate/context/AssociateContextProvider";
import {getStationCode} from "../network/NetworkUtil";
import AssociateDetailView from "../associate/AssociateDetailView";
import PageHeader from "../util/PageHeader";
import StageFilterV2Wrapper from "./StageFilterV2Wrapper"
import {MobileDisplay} from "../common/MobileDisplay";
import {StageFilterContext} from "./context/StageFilterContext";
import StageTabViewSelector from "./StageTabViewSelector";
import PlanManagementView from "./PlanManagementView";

const StageView = (props) => {
    const {configViewModel, configDispatch} = useContext(CapabilityContext)
    const {associateViewModel} = useContext(AssociateContext)
    const stationCode = getStationCode();
    const {viewModelF} = useContext(StageFilterContext)

    useEffect(() => {
        logCounterMetric(stationCode, STAGE_TAB_METRIC_KEY, RSWS_GET_CONFIG);
        Promise.all([getDocumentURL(), getNodeCapability()]).then(result => {
            //const result = ["https://logistics-co-uk-preprod.amazon.com",{capability: "\""+CORE_AMZL+"\""}];
            const model = {
                capability: parseCapabilitiesResponse(result[1]),
                baseUrl: getBaseUrl(result[0])
            }
            configDispatch({type: 'GET_CAPABILITIES', data: model});
            configDispatch({
                type: 'GET_STATION_CONFIG',
                data: {
                    dispatcher: configDispatch,
                    baseUrl: model.baseUrl
                }
            });
        })
    }, []);

    useEffect(() => {
        if (configViewModel.capability !== '' && configViewModel.stationConfig.initialised) {
            logCounterMetric(stationCode, STAGE_TAB_METRIC_KEY, RSWS_GET_STATION_CONFIG_SUCCESS);
        }

    }, [configViewModel.stationConfig.initialised]);

    return (
        <div>
            {configViewModel.capability !== '' && configViewModel.stationConfig.initialised ?
                <div>
                    <MobileDisplay visibility={false}>
                        <AlertView />
                    </MobileDisplay>
                    <StageTabViewSelector/>
                    {(associateViewModel.associate.length === 0) ? <div>
                        {DEFAULT_CAPABILITIES.includes(configViewModel.capability) ? <PageHeader {...PAGE_HEADERS.STAGE} /> : null}
                        {viewModelF.stageTabViewType === PLAN_MANAGEMENT_VIEW ? <PlanManagementView/> : <div>
                        {DEFAULT_CAPABILITIES.includes(configViewModel.capability) ? <StageFilterV2Wrapper /> : <StageFilter />}
                        {DEFAULT_CAPABILITIES.includes(configViewModel.capability) ? <StageOverallStatusV2 /> : <StageOverallStatus />}
                        <StageViewSelector />
                            <RouteStageTable history={props.history} /> </div>}
                    </div> : <AssociateDetailView />}

                </div>
                : null}
        </div>
    )
}

export default StageView


// WEBPACK FOOTER //
// ./src/components/stageStatus/StageView.js